// JavaScript Document

//Project Settings Start
var AnalyticsType = 'google';
var basicDomain = '55963503-1';
var alternativDomain = null;
var dsSite = 'https://www.mts-gruppe.com/datenschutz/';                                       //href zu Datenschutzseite
var en_dsSite = 'https://www.mts-gruppe.com/en/privacy-policy/';                                       //href zu Datenschutzseite
//Project Settings Ende



//Style Settings Start
var defaultBG = "#FFFFFF";
var hoverBG = "#898f97";
var agreeBG = "#28a745";
var disagreeBG = "#999999";
var defaultColor = "#082136";
var linkColor = "#4b6272";
var defaultOpacity = 1;


//Button STyle
var additionalBorderStyles_1 = " border-radius:10px;";
var additionalBorderStyles_Left = " border-radius:10px; border-top-right-radius:0px; border-bottom-right-radius:0px;";
var additionalBorderStyles_Right = "border-radius:10px; border-top-left-radius:0px; border-bottom-left-radius:0px;";
//Style Settings Ende



//Content Settings Start

var cInfoText = "Unsere Website verwendet Cookies, die uns helfen, unsere Website zu verbessern und unseren Kunden den bestmöglichen Service zu bieten. Indem Sie auf 'Akzeptieren' klicken, erklären Sie sich mit unseren Cookie-Richtlinien einverstanden. <a href='"+ dsSite + "' target='_blank' style='color:"+linkColor+"'>Erfahren Sie mehr.</a>";
var cBasicText = "<b>Grundlegende Tools</b>, die wesentliche Services und Funktionen ermöglichen, einschließlich Identitätsprüfung, Servicekontinuität und Standortsicherheit. Diese Option kann nicht abgelehnt werden.";
var cAnalyticText = "<b>Google Suche</b>, die anonyme Daten über Nutzung und -Funktionalität sammelt. Diese Suchfunktion, speziell für unsere Internet-Inhalte, steht Ihnen bei einer Ablehnung nicht zur Verfügung.";
// var cAnalyticText = "<b>Analytik Tools</b>, die anonyme Daten über Website-Nutzung und -Funktionalität sammeln. Wir nutzen die Erkenntnisse, um unsere Produkte, Dienstleistungen und das Benutzererlebnis zu verbessern.";
var cBtnLabelYes = "Akzeptieren";
var cBtnLabelNo = "Ablehnen";
var cBtnLabelOn = "An";
var cBtnLabelOff = "Aus";
var dispTxtShow = "Details zeigen";
var dispTxtHide = "Details verbergen";


var en_cInfoText = "Our website uses cookies to help us improve our website and provide the best possible service to our customers. By clicking 'Accept', you agree to our cookie policy. <a href='"+ en_dsSite + "' target='_blank' style='color:"+linkColor+"'>Learn more.</a>";
var en_cBasicText = "<b>Basic tools</b> that enable essential services and functions, including identity verification, service continuity, and site security.";
var en_cAnalyticText = "<b>Analytics tools</b> that collect anonymous data about site usage and functionality. We use the insights to improve our products, services and user experience.";
var en_cBtnLabelYes = "Accept";
var en_cBtnLabelNo = "Reject";
var en_cBtnLabelOn = "On";
var en_cBtnLabelOff = "Off";
var en_dispTxtShow = "Show Details";
var en_dispTxtHide = "Hide Details";

if (window.location.href.indexOf("/en/") >= 0){

    cInfoText = en_cInfoText;
    cBasicText = en_cBasicText;
    cAnalyticText = en_cAnalyticText;
    cBtnLabelYes = en_cBtnLabelYes;
    cBtnLabelNo = en_cBtnLabelNo;
    cBtnLabelOn = en_cBtnLabelOn;
    cBtnLabelOff = en_cBtnLabelOff;
    dispTxtShow = en_dispTxtShow;
    dispTxtHide = en_dispTxtHide;

}


var buttonStyle = "min-width:80px; width:150px; margin:10px; cursor:pointer; padding:8px; border: solid "+hoverBG+" 1px; text-decoration: none; background-color:transparent; color:"+hoverBG+"; outline:0;";
var buttonStyleInvert = "min-width:80px; width:150px; margin:10px; cursor:pointer; padding:8px; border: solid "+defaultBG+" 1px; text-decoration: none; color:"+defaultBG+"; background-color:"+hoverBG+"; outline:0;";
var buttonStyleLe = "background-color:transparent; cursor:pointer; padding:8px; padding-left:20px;; padding-right:15px; border: solid "+defaultColor+" 1px; border-right:none; text-decoration: none; outline:0;";
var buttonStyleRi = "background-color:transparent; cursor:pointer; padding:8px; padding-right:20px;; padding-left:15px; border: solid "+defaultColor+" 1px; border-left:none; text-decoration: none; outline:0;";

var buttonHoverEffect = " onMouseOver='setHover(this);' onMouseOut='unsetHover(this);' ";
var buttonHoverEffectInvert = " onMouseOver='setHoverInvert(this);' onMouseOut='unsetHoverInvert(this);' ";


var cookieStatus;

//Content Settings Ende


function startAnalyticsScript() {
    $('.cookieWrapper').on('click', function(){
        showCookieAlert();
    });

	var cookieStatus = checkCookieStatus();
	if(cookieStatus['allowGeneral']!=='true') {
        showCookieAlert();
        if(cookieStatus['allowAnalytics']==='true') {
            $('.coAnalytic .agree').css({'background-color':agreeBG});
            $('.coAnalytic .disagree').css({'background-color':defaultBG});
        }else{
            $('.coAnalytic .disagree').css({'background-color':disagreeBG});
        }
    }else{
        if((cookieStatus['allowAnalytics']==='true')) {
            setGeneralAnalytics(AnalyticsType, basicDomain, alternativDomain)
		}else{
            $('.headerSearchIcon').remove();
		}

	}
}
function checkCookieStatus(){
	var status = new Array();
	var cook = document.cookie.split("; ");
	var valU = new Array();
	for (i=0; i<cook.length; i++){
		valU[i] = cook[i].split("=")
		status[valU[i][0]] = valU[i][1];
 	}
 	return status;
}

function setHover(_el){
    $(_el).css({'background-color': hoverBG, 'color':defaultBG })
}
function unsetHover(_el){
    $(_el).css({'background-color': defaultBG, 'color':hoverBG })
}

function setHoverInvert(_el){
    $(_el).css({'background-color': defaultBG, 'color':hoverBG, 'border':'1px solid '+hoverBG })
}
function unsetHoverInvert(_el){
    $(_el).css({'background-color': hoverBG, 'color':defaultBG, 'border':'1px solid '+defaultBG })
}


function confirmGeneral(){
    cookieStatus = checkCookieStatus();
    // if(cookieStatus['allowAnalytics']!=='true'){
    //     if(cookieStatus['allowAnalytics']==='false'){
    //         document.cookie = "allowGeneral=true; expires=Thu, 18 Dec 2080 12:00:00 UTC;path=/;";
    //     }else{
        	document.cookie = "allowGeneral=true; expires=Thu, 18 Dec 2080 12:00:00 UTC;path=/;";
           	document.cookie = "allowAnalytics=true; expires=Thu, 18 Dec 2080 12:00:00 UTC;path=/;";
    //     }
    // }
	closeFrame();
}
function rejectGeneral(){
    deleteAllCookies();
    cookieStatus = checkCookieStatus();
    document.cookie = "allowGeneral=true; expires=Thu, 18 Dec 2080 12:00:00 UTC;path=/;";
    document.cookie = "allowAnalytics=false; expires=Thu, 18 Dec 2080 12:00:00 UTC;path=/;";
	closeFrame();
}
function confirmAnalytics(_el){
	$(_el).parent().find('button').css({'background-color':defaultBG});
	$(_el).css({'background-color':agreeBG});
	document.cookie = "allowAnalytics=true; expires=Thu, 18 Dec 2080 12:00:00 UTC;path=/;";
    document.cookie = "allowGeneral=true; expires=Thu, 18 Dec 2080 12:00:00 UTC;path=/;";
	//closeFrame();
}
function rejectAnalytics(_el){
    $(_el).parent().find('button').css({'background-color':defaultBG});
    $(_el).css({'background-color':disagreeBG});
	document.cookie = "allowAnalytics=false; expires=Thu, 18 Dec 2080 12:00:00 UTC;path=/;";
    document.cookie = "allowGeneral=true; expires=Thu, 18 Dec 2080 12:00:00 UTC;path=/;";
	//closeFrame();
}

function closeFrame(){
	$('#cookAlert').hide();
   cookieStatus = checkCookieStatus();
	if(cookieStatus['allowAnalytics']==='true') {
		setGeneralAnalytics(AnalyticsType, basicDomain, alternativDomain);
	}
}

function showCoDetails(_this){
    $('#coDetails').toggle();
	var dispTxt = $(_this).html();
	if(dispTxt === dispTxtShow) {
		$(_this).html(dispTxtHide);
    }else{
        $(_this).html(dispTxtShow);
	}
}

function hideDetailsBox(){
	$('#detailsBox').hide();
}

function showCookieAlert(){
	var htm = "";
	htm += "<div id='cookAlert' style='z-index:50000; position:fixed; width:100%; height:auto; bottom:0px; left:0%; font-size:15px; background-color:"+defaultBG+"; color:"+defaultColor+"; opacity: "+defaultOpacity+"; padding:14px 22px; padding-top:30px; border-top:1px solid "+defaultColor+";'> "
	htm += "    <div class='container' style='text-align:center;'> "+cInfoText;
	htm += "	    <div onClick='closeFrame();' style='position:absolute; right:6px; top:6px; width:20px; height:20px; line-height:14px; text-align:center; font-size:18px; cursor:pointer;'> x</div>";
	htm += "	    <div  class='col-xs-12 generalBtnBox row' style='text-align:center; padding:10px; padding-top:40px; justify-content:center;'>";
	htm += "	        <div  class='col-xs-hidden col-sm-hidden  col-md-hidden col-lg-3'></div>";
	htm += "	        <div  class='col-xs-12 col-sm-4  col-md-4 col-lg-2'><button "+buttonHoverEffectInvert+" onClick='confirmGeneral();' style='"+buttonStyleInvert+"'>"+ cBtnLabelYes +"</button></div>";
	htm += "	        <div  class='col-xs-12 col-sm-4  col-md-4 col-lg-2'><button "+buttonHoverEffect+" onClick='rejectGeneral();' style='"+buttonStyle+"'>"+cBtnLabelNo+"</button></div>";
	htm += "	        <div  class='col-xs-12 col-sm-4  col-md-4 col-lg-2'><button "+buttonHoverEffect+" onClick='showCoDetails(this);' style='"+buttonStyle+"'>"+dispTxtShow+"</button></div>";
    htm += "	        <div  class='col-xs-hidden col-sm-hidden  col-md-hidden col-lg-3'></div>";
    htm += "		</div>";
	htm += "		<div id='coDetails' class='row' style='margin-top:20px; display:none;'>";
	htm += "			<div class='col-md-6 col-xs-12 coBasic' style='text-align:left;padding:10px;'>"+cBasicText;
    htm += "			</div>";
	htm += "			<div class='col-md-6 col-xs-12 coAnalytic' style='text-align:left;padding:10px;'>"+cAnalyticText+"<br><br>";
	// htm += "				<button class='agree' onClick='confirmAnalytics(this);' style='float:left; "+buttonStyleLe+"'>"+cBtnLabelOn+"</button> ";
	// htm += "				<button class='disagree' onClick='rejectAnalytics(this);' style='background-color:"+disagreeBG+";  float:left;  "+buttonStyleRi+"'>"+cBtnLabelOff+"</button>";
	htm += "			</div>";
	htm += "		</div>";
	htm += "    </div>";
	htm += "</div>";
    if($('#cookAlert').length<1){
        $('body').append(htm);
    }else{
        $('#cookAlert').show();
    }
}

function deleteAllCookies() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;";
    }
}


/*Goggle Analytic
	_type 				: 'google' oder 'matomo'
	_allowAnalytics		: true oder false
	_domain				: '"
	 _altDomain			: ''
*/

function setGeneralAnalytics(_type, _domain, _altDomain){
	switch(_type){
		case 'google': doGoogleAnalytics( _domain);
			break;
		case 'matomo': setMatomo(_domain, _altDomain);
			break;
	}
}



function setMatomo(_domain, _altDomain){
	var domainArray = _domain.split(',');
    var domainString = '';
	for(var i = 0; i<domainArray.length; i++){
		if(i===0){
            domainString += '"*.' + domainArray[i] + '"';
		}else{
            domainString += ',"*.' + domainArray[i] + '"';
		}
	}
    var altDomainString = '';
    if(_altDomain!==null){
        altDomainString = _altDomain;
    }else{
        altDomainString = _domain;
    }
    doMamoto(domainString, altDomainString);
}

function doMamoto(domainString,altDomainString){

}


function doGoogleAnalytics(domainString){
    // let myurl = 'https://www.googletagmanager.com/gtag/js?id=UA-127322075-1'
    // let myscript = document.createElement('script');
    // myscript.type = 'text/javascript';
    // myscript.async = true;
    // myscript.src = myurl;
    // document.getElementsByTagName('head')[0].appendChild(myscript);
    //
    //
    // window.dataLayer = window.dataLayer || [];
    // function gtag(){dataLayer.push(arguments);}
    // gtag('js', new Date());
    // gtag('config', 'UA-127322075-1');

    initGCS();


}



setTimeout(startAnalyticsScript,250);

